import { render } from "./Header.vue?vue&type=template&id=0c326d36&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=0c326d36&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/ms-frontend-vue_us_qa_v1.39.20_2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__